import React from 'react'
import classNames from 'classnames'
import { IconGripVertical } from '@tabler/icons-react'

import './DragAndDrop.scss'

// HTML button elements don't work with react-beautiful-dnd so we use a div instead
export const DragAndDropButton = ({
  provided,
  snapshot,
  invisible,
  outer,
  readOnly,
  disabled,
  isHidden,
}) => {
  return (
    <div
      className={classNames('balto-button square draggable-button basic small', {
        'is-dragging': snapshot.isDragging,
        hidden: !outer,
        'hidden-outer': outer,
        'hidden-permanent': isHidden,
        'read-only': readOnly,
        disabled,
      })}
      {...provided.dragHandleProps}
    >
      <IconGripVertical
        className={classNames('draggable-icon', { 'visibility-hidden': invisible })}
      />
    </div>
  )
}
